import React, { useState, useEffect } from "react";
import {
  Td,
  Box,
  Flex,
  Text,
  Select,
  useToast,
  Input,
  IconButton,
  SimpleGrid,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  FormControl,
  FormLabel,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Stack,
  ModalFooter,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Table,
  Thead,
  Tbody,
  Tr,
  Icon,
  Th,
  Badge,
} from "@chakra-ui/react";
import {
  FaEllipsisV,
  FaPlus,
  FaBook,
  FaFileAlt,
  FaClipboardList,
  FaEdit,
  FaPrint,
} from "react-icons/fa";
import Axios from "axios";
import "../Teacher/teacher.css";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Subject = () => {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [subjectName, setSubjectName] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await Axios.get(
          `${BASE_URL}/admin/subject/list_subject.php`
        );
        if (response.data && Array.isArray(response.data.data)) {
          setSubjects(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };
    fetchSubjects();
  }, []);

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    const sortedSubjects = [...subjects];
    if (e.target.value === "name") {
      sortedSubjects.sort((a, b) => a.subject.localeCompare(b.subject));
    } else if (e.target.value === "type") {
      sortedSubjects.sort((a, b) => a.sub_type.localeCompare(b.sub_type));
    }
    setSubjects(sortedSubjects);
  };

  const filteredSubjects = subjects.filter((subject) =>
    subject.subject.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredSubjects.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredSubjects.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleMenuAction = (action, subject) => {
    setSelectedSubjectId(subject.id);
    if (action === "editsubject") {
      setIsEditMode(true);
      setSubjectName(subject.subject);
      setDescription(subject.description);
      setType(subject.sub_type);
      onOpen();
    } else if (action === "deletesubject") {
      handleDelete(subject.id); // Trigger delete function
    }
  };

  const handleSubmit = async () => {
    if (!subjectName || !description || !type) {
      setError("All fields are required");
      return;
    }

    try {
      if (isEditMode) {
        const response = await Axios.put(
          `${BASE_URL}/admin/subject/edit_subject.php`,
          {
            subject_id: selectedSubjectId,
            subject: subjectName,
            description,
            sub_type: type,
            pass: sessionStorage.getItem("user_id"),
          }
        );

        if (response.data.success) {
          setSubjects(
            subjects.map((subject) =>
              subject.id === selectedSubjectId
                ? {
                    ...subject,
                    subject: subjectName,
                    description,
                    sub_type: type,
                  }
                : subject
            )
          );
          onClose();
        } else {
          console.error("Update failed:", response.data.message);
          toast({
            title: "Failed to Update Subject",
            description: "Failed to update the subject. Please try again.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      } else {
        const response = await Axios.post(
          `${BASE_URL}/admin/subject/create_subject.php`,
          {
            subject: subjectName,
            description,
            sub_type: type,
            pass: sessionStorage.getItem("user_id"),
          }
        );

        if (response.data.success) {
          // Refetch subjects after creation to ensure the ID is correctly set
          const fetchSubjects = await Axios.get(
            `${BASE_URL}/admin/subject/list_subject.php`
          );
          if (fetchSubjects.data && Array.isArray(fetchSubjects.data.data)) {
            setSubjects(fetchSubjects.data.data);
          }
          onClose();
        } else {
          console.error("Creation failed:", response.data.message);
          toast({
            title: "Failed to Create Subject",
            description: "Failed to create the subject. Please try again.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast({
        title: "Error Processing Request",
        description:
          "An error occurred while processing your request. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleDelete = async (subjectId) => {
    const p = {
      subject_id: subjectId,
      // subject_id: subjectId,pass:sessionStorage.getItem('user_id')
    };
    console.log(p);

    try {
      const response = await Axios.delete(
        `${BASE_URL}/admin/subject/delete_subject.php`,
        {
          data: { subject_id: subjectId },
          // data: { subject_id: subjectId,pass:sessionStorage.getItem('user_id') },

          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setSubjects(subjects.filter((subject) => subject.id !== subjectId));
        toast({
          title: "Subject Deleted Successfully",
          description: "The subject has been deleted successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Failed to Delete Subject",
          description: "Failed to delete the subject. Please try again.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error Deleting Subject",
        description:
          "An error occurred while deleting the subject. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const renderRow = (subject) => (
    <Tr key={subject.id}>
      <Td>{subject.subject}</Td>
      <Td>{subject.description}</Td>
      <Td>{subject.sub_type}</Td>
      <Td py="12px" px="20px" textAlign="left">
        <Badge
          colorScheme={subject.status === "Active" ? "green" : "green"}
          borderRadius="full"
          px={4}
          py={1}
          fontSize="11px"
          boxShadow="md"
          position="relative"
        >
          {subject.status === "Active" ? "Active" : "Active"}
        </Badge>
      </Td>
      <Td>
        <Menu>
          <MenuButton
            as={IconButton}
            size="sm"
            variant="ghost"
            icon={<FaEllipsisV />}
          />
          <MenuList>
            <MenuItem onClick={() => handleMenuAction("editsubject", subject)}>
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => handleMenuAction("deletesubject", subject)}
            >
              Delete
            </MenuItem>{" "}
          </MenuList>
        </Menu>
      </Td>
    </Tr>
  );

  return (
    <Box maxWidth="100%" overflowX="auto">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Subject List</h1>
            <div className="action-buttons">
              <Button
                className="add-teacher-button"
                leftIcon={<FaPlus />}
                colorScheme="teal"
                onClick={() => {
                  setIsEditMode(false); // Ensures you're in Add mode
                  setSubjectName(""); // Clear the form fields
                  setDescription("");
                  setType("");
                  onOpen(); // Opens the modal for adding a new subject
                }}
              >
                <Box display={{ base: "none", md: "block" }}>Subject</Box>
              </Button>
            </div>
          </div>

          <div className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span>Subject</span> / <span>Subject List</span>
          </div>
        </div>
        <Box p={6}>
          <Flex
            justify="space-between"
            align="center"
            className="sb"
            // mb={1}
            p={3}
            direction={{ base: "column", md: "row" }}
          >
            <Flex align="center">
              <Text mr={2}>Rows Per Page</Text>
              <Select
                value={rowsPerPage}
                width="100px"
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
              </Select>
            </Flex>

            <Stack
              spacing={4}
              direction={{ base: "column", md: "row" }}
              width={{ base: "100%", md: "350px" }}
            >
              <Select
                mt={{ base: "2", md: "0" }}
                placeholder="Sort by"
                value={sortOption}
                onChange={handleSortChange}
              >
                <option value="name">Name</option>
                <option value="type">Type</option>
              </Select>
              <Stack
                direction="row"
                spacing={2}
                width={{ base: "100%", md: "350px" }}
              >
                <Input
                  type="text"
                  placeholder="Search by Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Stack>
            </Stack>
          </Flex>

          <div style={{ overflowX: "auto" }}>
            <Table>
              <Thead>
                <Tr>
                  <Th>Subject</Th>
                  <Th>Description</Th>
                  <Th>Type</Th>
                  <Th>Status</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>{currentData.map((subject) => renderRow(subject))}</Tbody>
            </Table>
          </div>

          <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </Box>
      </div>

      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon as={isEditMode ? FaEdit : FaPlus} boxSize={5} mr={2} />
            {isEditMode ? "Edit Subject" : "Add Subject"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <Flex gap={6} direction={{ base: "column", md: "column" }}>
              <FormControl isRequired>
                <FormLabel>
                  <Icon as={FaBook} mr={1} color="teal.500" />
                  Subject Name
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={subjectName}
                  onChange={(e) => setSubjectName(e.target.value)}
                />
              </FormControl>
              <FormControl isRequired mt={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaFileAlt} mr={1} color="teal.500" />
                  Description
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormControl>
              <FormControl id="type" isRequired mt={4} isInvalid={!!error}>
                <FormLabel>
                  {" "}
                  <Icon as={FaClipboardList} mr={1} color="teal.500" />
                  Type
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select type"
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                    setError(""); // Clear error on change
                  }}
                >
                  <option value="Theory">Theory</option>
                  <option value="Practical">Practical</option>
                </Select>
                {/* {error && <FormErrorMessage>{error}</FormErrorMessage>} */}
              </FormControl>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              onClick={handleSubmit}
            >
              {isEditMode ? "Update" : "Create"}
            </Button>
            {/* <Button onClick={onClose} ml={3}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Subject;
